import { render, staticRenderFns } from "./DocumentAddEditModal.vue?vue&type=template&id=1c77e15e&scoped=true&"
import script from "./DocumentAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAddEditModal.vue?vue&type=style&index=0&id=1c77e15e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77e15e",
  null
  
)

export default component.exports